import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

import React from 'react';

import { baseTheme } from '../../../theme';
import HeaderNavItem from '../header-nav-item';
import { ROUTE_PATHS } from '../../../contants/ROUTE_PATHS';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
    navigationContainer: {
      justifyContent: 'center',
    },
  }),
);

export default function AdminHeaderNavigation(props: any): JSX.Element {
  const classes = useStyles(baseTheme);
  const isCurrentRoute = (path: string) => props.location.pathname === path;

  return (
    <Grid container item xs={1} md={4} className={classes.navigationContainer}>
      {/* <HeaderNavItem
        title="Engagement"
        href={ROUTE_PATHS.ADMIN_ENGAGEMENT}
        selected={isCurrentRoute(ROUTE_PATHS.ADMIN_ENGAGEMENT)} /> */}
      <HeaderNavItem
        title="Leaders"
        tooltip="Find, follow leaders, view leader posts"
        href={ROUTE_PATHS.ADMIN_LEADERS}
        selected={isCurrentRoute(ROUTE_PATHS.ADMIN_LEADERS)} />
      <HeaderNavItem
        title="Library"
        tooltip="Copied leader posts"
        href={ROUTE_PATHS.LIBRARY}
        selected={isCurrentRoute(ROUTE_PATHS.LIBRARY)} />
      <HeaderNavItem
        title="Groups"
        tooltip="Manage and create groups"
        href={ROUTE_PATHS.ADMIN_GROUPS}
        selected={isCurrentRoute(ROUTE_PATHS.ADMIN_GROUPS)} />
      <HeaderNavItem
        title="Posts"
        tooltip="Manage and create posts"
        href={ROUTE_PATHS.ADMIN_HOME}
        selected={isCurrentRoute(ROUTE_PATHS.ADMIN_HOME)} />
    </Grid>
  );
}
